import React from "react";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../../_helpers";

export function ScrollTop() {
  return (
      <div id="kt_scrolltop" className="scrolltop">
        <span className="svg-icon">
          <i className="flaticon2-up text-dark font-size-lg"></i>
        </span>{" "}
      </div>
  );
}
